import React from 'react';
import './App.css';
import Header from "./header/Header.js"
import Page from "./content/Page.js"
import Footer from "./Footer.js"

const App = () => {
  const imageSrc = "/static/images/";

  return (
    <div>
      <Header
        menuLogo="KE"
        menuOptions={[
          { name: "about-me-pg", type: "section", text: "About Me" },
          { name: "experience-pg", type: "section", text: "Experience" },
          { name: "projects-pg", type: "section", text: "Projects" },
          { name: "contact-me-pg", type: "link", text: "Contact Me" }]}
      ></Header>
      <Page
        projects={[
          { projectName: "KaylaElias.com", projectImageSrc: imageSrc + "rsz_kaylaeliascom_img.png", projectImageAlt: "Screenshot of kaylaelias.com", projectSubtitle: "August 2019 || React, HTML, JavaScript, CSS", projectText: "This whole website was designed and coded by me using React, HTML, JavaScript, and CSS.", projectCode: "" },
          { projectName: "Finance Tracker", projectImageSrc: imageSrc + "rsz_finance_tracker.jpg", projectImageAlt: "Pink Piggy Bank", projectSubtitle: "October 2017 || Java", projectText: "The Finance Tracker lets you input expenses and income for a specified period of time, and stores it for you. When you are ready, you can have it format the information into an easily readable text file to help you keep track and evaluate your finances.", projectCode: codeUtils.financeTracker },
          { projectName: "Code to HTML", projectImageSrc: imageSrc + "rsz_code_to_html.jpg", projectImageAlt: "Blue and Purple Code", projectSubtitle: "July 2017|| Java", projectText: "This project helps programmers post Java code to a website, by adding HTML escape characters and shortening long lines of code to a set length. I have used it to post all the code on this website.", projectCode: codeUtils.codeToHTML }
        ]}></Page>
      <Footer
        year="2020"
        creator="Kayla Elias"
        iconCreator="AJ Silberman"
        bgCreator="Daniel Absi from Pexels"></Footer>
    </div>
  );
}

const codeUtils = {
  codeToHTML: (`public class CodeToHTML {
  Scanner sc;
  PrintWriter pw;
  int maxLineLength = -1;

  public CodeToHTML(String fileName, int length) {
    maxLineLength = length;
    replaceEscapedCharacters(fileName);
  }
  
  public CodeToHTML(String fileName) {
    replaceEscapedCharacters(fileName);
  }
  
  private void replaceEscapedCharacters(String fileName) {
    try {
      File codeFile = new File(fileName);
      sc = new Scanner(codeFile);
      pw = new PrintWriter(codeFile.getAbsolutePath() + "_Escaped.txt");
      String line = "";
    
      while (sc.hasNextLine()) {
        line = sc.nextLine();
        line = line.replaceAll("\t", "     ");
        line = line.replaceAll("&lt;", "<");
        line = line.replaceAll("&gt;", ">");
    
        int length = line.length();
        if (maxLineLength != -1 && length > maxLineLength) {
          List < String > shortenedLines = shortenLine(line,
            length);
          for (int i = 0; i < shortenedLines.size(); i++) {
            pw.println(shortenedLines.get(i));
          }
        } else {
          pw.println(line);
        }
    
      }
    } catch (Exception ex) {
      ex.printStackTrace();
    } finally {
      sc.close();
      pw.close();
    }
  }
  
  private List < String > shortenLine(String line, int length) {
    List < String > res = new ArrayList <> ();
    int numOfSpaces = line.length() - line.replaceFirst("\\s*", "").length();
    Pattern p = Pattern.compile("\\s*[\\.\\)\\(\\[\\]\\d\\w\\W\\\\/\\s]{1," +
    (maxLineLength - 1 - numOfSpaces) + "}(\\s|$)");
  
    Matcher m = p.matcher(line);
    int count = 0;
    while (m.find()) {
      String addedLine = m.group();
      if (count > 0) {
        addedLine = addSpaces(numOfSpaces + 5) + addedLine;
      }

      res.add(addedLine);
      count++;
    }
    return res;
  }

  private String addSpaces(int numOfSpaces) {
    String spaces = "";
    for (int i = 0; i < numOfSpaces; i++) {
      spaces += " ";
    }
    return spaces;
  }
}`),
  financeTracker: (`public class Input {
  /*
  * isRunning: true = the finance tracker is running; false= the application will turn off.
  * queryString: the string that asks for input.
  * */
  String logFileName ="./logs/log";
  String printFileName ="./logs/print";
  Scanner scanner = new Scanner(System.in);
  String entry = "";
  boolean isRunning = true;
  String astrix = "*******************************************************************************\n";
  String mainQueryString = astrix
    + "What can I do for you?\n\n"
    + "- print: creates a summary of your finances.\n"
    + "- input: provides a list of questions for you to input a new expense or income.\n" 
    /*+ "- query: provides a list of questions you can ask the Finance Tracker program.\n" */
    + "- q    : quits the Finance Tracker program.\n"
    + astrix + "\n";
  boolean isInputMenu = false;
          
  public Input(){
    inputReader();
  }
          
  private void inputReader() {
    System.out.println("Welcome to your Finance Tracker!");
    while(isRunning) {
      System.out.print("\n\n" + mainQueryString);
      mainMenuSection();
    }
    System.out.println("\n\nThank you. Have a good day! =)");
  }
          
  private void mainMenuSection(){
    entry = scanner.nextLine();
    switch (entry.toLowerCase()) {
      case "print":
        printSection();
        break;
      case "input":
        isInputMenu = true;
        inputSection();
        break;
      case "q":
        isRunning = false;
        break;
      default: 
        System.out.println("\nInvalid Input.");
    }           
  }
          
  private void printSection() {
    /*Reads from a file and creates a pretty looking new file*/
    File writeFile = new File(printFileName);
    File readFile = new File(logFileName); 
    Scanner sc = null;
    PrintWriter writer = null;
    String line = "";
    int finalTotal = 0;
    int negativeTotal = 0;
    int positiveTotal = 0;
            
    try {
      sc = new Scanner(readFile);
      writer = new PrintWriter(writeFile);
              
      writer.printf("%-20s|%-20s|%-20s|%-20s|%-20s|%-20s\n"
        + "_______________________________________________________________________________________________________________________________"
        + "\n", 
        "Name", "Type", "Date Purchased", "Location", "Payment Type", "Price");
              
      while (sc.hasNextLine()) {
        line = sc.nextLine();
        String[] splitLine = line.split(";");
        for(int i = 0; i < splitLine.length; i++) {
          writer.printf("%-20s", splitLine[i].trim());
          if(i < splitLine.length-1) {
            writer.printf("|");
          } else {
            int price = Integer.parseInt(splitLine[i]);
            if(price > 0) {
              positiveTotal += price;
            } else {
              negativeTotal += price;
            }
            finalTotal += price;
          }
        }
        writer.println();
      } 
      writer.printf("_______________________________________________________________________________________________________________________________"
        + "\n%98s %d%10s %d\n"
        + "\n%105s %d", "Expenses: ", negativeTotal, "|Income:", positiveTotal, "Total:", finalTotal);
    } catch (FileNotFoundException e) {
      e.printStackTrace();
    } finally {
      sc.close();
      writer.close();
    }
  }
          
  private void inputSection() {
    while(isInputMenu) {
      System.out.println("\n" + astrix 
        +"Please choose an option:\n"
        +  "\nA: Single entry."
        +  "\nB: Bulk entry."
        +  "\nC: Return to main menu."
        +  "\nQ: Quit.\n"
        + astrix);
      entry = scanner.nextLine();
      switch (entry.toLowerCase()){
        case "a":
          singleEntry();
          break;
        case "b":
          bulkEntry();
          break;
        case "c":
          isInputMenu = false;
          break;
        case "q":
          isInputMenu = false;
          isRunning = false;
          break;
        default:
          System.out.println("\nInvalid Input.");
      }
    }
  }	
  
  private void singleEntry() {
    boolean isCorrectEntry = false;
    String expense = "";
    while(!isCorrectEntry) {
      System.out.println("\nPlease enter the following: "
              +  "item_name; item_type; price; date_purchased; location; payment_type: \n");
      expense = scanner.nextLine();
      System.out.print("\n\nIs this correct? (Enter \'yes\' or \'no\'): "
              +  expense + ": ");
      entry = scanner.nextLine();
      switch (entry.toLowerCase()) {
        case "yes":
          isCorrectEntry = true;
          boolean isLogged = logEntry(expense, false);
          if(isLogged) {
            System.out.println("\nEntry Added.");
          } else {
            System.out.println("\nFailed to add Entry. Please check error log.");
          }
          break;
        case "no":
          break;
        default:
          System.out.println("\nInvalid Input.");
      }
    }
  }
  
  private void bulkEntry() {
    boolean isCorrectEntry = false;
    String fileName = "";
    while(!isCorrectEntry) {
      System.out.println("\nPlease enter the file name for bulk entry: \n");
      fileName = scanner.nextLine();
      System.out.print("\n\nIs this correct? (Enter \'yes\' or \'no\'): "
              +  fileName + ": ");
      entry = scanner.nextLine();
      switch (entry.toLowerCase()) {
        case "yes":
          isCorrectEntry = true;
          boolean isLogged = logEntry(fileName, true);
          if(isLogged) {
            System.out.println("\nEntries Added.");
          } else {
            System.out.println("\nFailed to add some Entries. Please check error log.");
          }
          break;
        case "no":
          break;
        default:
          System.out.println("\nInvalid Input.");
      }
    }
  }

  private boolean logEntry(String expense, boolean isBulk) {
    try {
      File writeFile = new File(logFileName);
      boolean isOutputFile = checkFile(writeFile);
      PrintWriter writer = null;
      if(isBulk){
        if(isOutputFile) {
          writer = new PrintWriter(new FileOutputStream(writeFile, true));
        } else {
          writer = new PrintWriter(writeFile);
        }
        
        File readFile = new File(expense); 
        Scanner sc = new Scanner(readFile); 
        
        while (sc.hasNextLine()) {
          writer.println(sc.nextLine()); 
        } 
        sc.close();
      } else {
        if(isOutputFile) {
          writer = new PrintWriter(new FileOutputStream(writeFile, true));
        } else {
          writer = new PrintWriter(writeFile);
        }
        writer.println(expense);
      }
      writer.close();
      return true;
    } catch (Exception e) {
      System.out.println(e);
      return false;
    }
  }
  
  private boolean checkFile(File file) {
    if(file.exists() && !file.isDirectory()) {
      return true;
    } else {
      return false;
    }
  }
}`),
};

export default App;
